<template>
  <div align="Left">
    <md-card id="doctors2" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">local_hospital</i>
        </div>
        <h4 class="title">Doctors</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="searchQuery" @keyup.enter="handleSearch" />
            </md-field>
          </div>
          <div class="md-layout md-gutter md-layout-item md-size-20" v-if="organizations.length > 2">
            <md-field class="md-sm">
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-button class="md-icon-button md-primary" @click="handleSearch">
              <md-icon>search</md-icon>
            </md-button>
          </div>
          <div class="md-layout md-gutter md-layout-item md-alignment-center-right" :class="[
            { 'md-size-40': organizations.length > 2 },
            { 'md-size-60': organizations.length <= 2 }
          ]">
            <md-button class="md-icon-button md-primary" @click="handleAdd">
              <md-icon>add</md-icon>
              <md-tooltip md-direction="bottom">Add new doctor</md-tooltip>
            </md-button>
            <md-button class="md-icon-button" @click="handleRefresh">
              <md-icon>refresh</md-icon>
              <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
            </md-button>
          </div>
        </div>

      </md-card-header>

      <md-card-content style="padding-top: 0px">
        <md-table v-if="!isLoading" :value="filteredDoctors" class="table-shopping table-striped table-hover">
          <md-table-row>
            <md-table-empty-state :md-description="`No doctors found for this search value`"
              md-label="No doctors found">
            </md-table-empty-state>
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Name">
              <span>{{ (item.firstName || "-") + " " + (item.lastName || "-") }}</span>
            </md-table-cell>

            <md-table-cell md-label="Email">
              {{ item.email || "-" }}
            </md-table-cell>

            <md-table-cell md-label="Phone">{{ item.cellNumber || "-" }}</md-table-cell>
            <md-table-cell md-label="Act as Reader">{{ item.isReader ? "Yes" : "No" }}</md-table-cell>
            <md-table-cell md-label="Status">{{ getDoctorStatus(item.status) || "-" }}</md-table-cell>
            <md-table-cell md-label="Actions">
              <div style="display: flex">
                <md-button v-if="isAdmin" style="margin-right: 0.5rem" class="md-icon-button md-primary"
                  @click="handleActivate(item)">
                  <md-icon>{{ item.status == 2 ? "close" : "check" }}</md-icon>
                  <md-tooltip md-direction="bottom">
                    {{ item.status == 2 ? "Deactivate" : "Activate" }}
                  </md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click="handleEdit(item)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="bottom">Edit doctor</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-danger" style="margin-left: 0.5rem" @click="handleRemove(item)">
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="bottom">Remove doctor</md-tooltip>
                </md-button>
                <md-button v-if="isSuperAdmin" style="margin-left: 0.5rem" class="md-icon-button md-primary"
                  @click="openOrgEditModal(item)">
                  <md-icon>business</md-icon>
                  <md-tooltip md-direction="bottom">Edit organizations</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" style="margin-left: 0.5rem" @click="handleChangePassword(item)">
                  <md-icon>manage_accounts</md-icon>
                  <md-tooltip md-direction="bottom">Change password</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex; align-items: center">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startDoctor }}</u></b>
                to
                <b><u>{{ endDoctor }}</u></b>. Total of
                <b><u>{{ totalDoctors }}</u></b>
                doctors.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading || isLoadingDoctor" />

    <RegisterDoctor v-if="createModalOpen" :doctor="selectedDoctor" :is-edit="isEdit" :is-modal="true"
      @close="closeRegisterDoctor" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import RegisterDoctor from "@/pages/Auth/RegisterDoctor.vue"
import loader from "@/components/GlobeChek/loader.vue"
import Swal from "sweetalert2"

export default {
  components: {
    loader,
    RegisterDoctor
  },
  data() {
    return {
      isAdmin: (sessionStorage.getItem("usertype") == "Super" || sessionStorage.getItem("usertype") === 'Administrator'),
      isSuperAdmin: sessionStorage.getItem("usertype") == "Super",
      createModalOpen: false,
      selectedDoctor: null,
      tableData: [],
      searchQuery: "",
      searchedData: [],
      isLoading: false,
      isLoadingDoctor: false,
      isEdit: false,
      offset: 0,
      limit: 50,
      pagination: {
        perPage: 50,
        perPageOptions: [5, 10, 20, 50, 100, 200]
      },
      specializations: [],
      countries: [],
      states: [],
      currentOrganization: JSON.parse(sessionStorage.getItem("organizations")).length === 1 ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId : (localStorage.getItem("currentOrgSelectedForFilters") || "all"),
      organizations: [
        { label: 'All', value: 'all' },
        ...JSON.parse(sessionStorage.getItem('organizations')).map(i => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        }),
      ],
      getDoctorStatus: (status) => {
        switch (status) {
          case 1:
          case "1":
            return "Pending"
          case 2:
          case "2":
            return "Active"
          case 3:
          case "3":
            return "Inactive"
          default:
            return " - "
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "doctorsList",
      "totalDoctors",
      "doctorReg",
      "drPersonal",
      "drCredentials",
      "drPractice",
      "drComments",
      "drEditInfo"
    ]),

    filteredDoctors() {
      return this.tableData
    },
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.totalDoctors
    },
    startDoctor() {
      return this.totalDoctors === 0 ? 0 : this.offset + 1
    },
    endDoctor() {
      return Math.min(this.offset + this.limit, this.totalDoctors)
    }
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
    }
  },
  mounted() {
    this.isLoading = true
    this.fetchDoctors({ orgId: this.currentOrganization })
  },
  methods: {
    ...mapActions(["listAllDoctors", "listDoctorById", "updateUserStatus"]),
    async handleChangePassword(user) {
      this.isLoadingDoctor = true
      const detailedDoctor = await this.listDoctorById(user.id)
      this.$emit("openChangePasswordModal", { name: `${detailedDoctor.Personal.firstName} ${detailedDoctor.Personal.lastName}`, personId: detailedDoctor.EditInfo.personID })
      this.isLoadingDoctor = false
    },
    async handleActivate(doctor) {
      const payload = {
        userId: doctor.id,
        status: doctor.status === 2 ? 3 : 2
      }

      try {
        const res = await this.updateUserStatus({ payload, userType: "doctor" })
        if (res) {
          this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          title: "Error!",
          text: "An error occurred while updating the doctor status.",
          icon: "error"
        })
      }
    },
    async fetchDoctors({ search = null, orgId = null } = {}) {
      this.isLoading = true
      try {
        const response = await this.listAllDoctors({
          offset: this.offset,
          limit: this.limit,
          search: search,
          orgId: orgId != 'all' ? orgId : null
        })
        this.tableData = response.doctors
        if (this.tableData) {
          const uniqueIds = new Set()
          const array = this.tableData
          this.tableData = array.filter((item) => {
            if (uniqueIds.has(item.id)) {
              return false
            }
            uniqueIds.add(item.id)
            return true
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    updateLimit() {
      this.limit = this.pagination.perPage
      this.offset = 0
      this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    handleSearch() {
      this.offset = 0
      localStorage.setItem('currentOrgSelectedForFilters', this.currentOrganization)
      this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    defineAttribute(attribute) {
      if (attribute) return attribute
      else return ""
    },
    defineQualification(qualification) {
      const title = qualification.split(" ")[1]
      let lookupId = ""
      switch (title) {
        case "MD":
          lookupId = "341"
          break
        case "OD":
          lookupId = "342"
          break
        case "DO":
          lookupId = "343"
          break
        default:
          lookupId = null
          break
      }
      return lookupId
    },
    async handleEdit(item) {
      let orgID = sessionStorage.getItem("userOrgID")

      if (!orgID || orgID == "null") {
        orgID = ["3e82aaf6-3237-4754-9238-c360a365a5a4"]
      }
      this.isLoadingDoctor = true
      const detailedDoctor = await this.listDoctorById(item.id)
      this.isLoadingDoctor = false
      this.isEdit = true
      this.$store.dispatch("updateDoctorReg", detailedDoctor)
      this.createModalOpen = true
    },
    async handleRemove(doctor) {
      const userId = sessionStorage.getItem("userID")
      let id = doctor.id
      if (doctor.expr1) id = doctor.expr1
      const url = `${process.env.VUE_APP_URL}/doctors/${userId}/${id}`

      const response = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this doctor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      })
      if (response.value) {
        this.isLoading = true
        try {
          await window.axios.delete(url)
          Swal.fire({
            title: "Deleted!",
            text: "Doctor has been deleted.",
            confirmButtonText: "OK"
          })
          await this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
        } catch (error) {
          Swal.fire({
            title: "Error!",
            text: "Error: " + error,
            confirmButtonText: "Try Again"
          })
        } finally {
          this.isLoading = false
        }
      }
    },

    handleAdd() {
      this.selectedDoctor = null
      this.isEdit = false
      this.createModalOpen = true
    },
    closeRegisterDoctor(params = false) {
      this.$store.dispatch("clearDoctorReg")
      this.isEdit = false
      this.createModalOpen = false
      if (params) {
        this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    handleRefresh() {
      this.offset = 0
      this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.fetchDoctors({ search: this.searchQuery, orgId: this.currentOrganization })
      }
    },
    async openOrgEditModal(doctor) {
      try {
        this.isLoadingDoctor = true
        const detailedDoctor = await this.listDoctorById(doctor.id)
        this.isLoadingDoctor = false
        this.$emit("openOrgEditModal", detailedDoctor)
      } catch (error) {
        console.error("Error fetching doctor details:", error)
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch doctor details.",
          confirmButtonText: "OK"
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: left;
}

.table-shopping {
  table>thead>tr>th {
    text-transform: uppercase;
  }

  table>thead>tr>.md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-name {
    min-width: 200px;
  }

  .td-phone {
    text-align: left;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
